import React from 'react'

import SectionSeleksiKS from './components/SectionSeleksiKS'
import SectionSeleksiPS from './components/SectionSeleksiPS'

export const HomeIndex = () => {
  return (
    <div className="flex justify-center">
      <div className="flex w-[780px] flex-col gap-6">
        <SectionSeleksiKS />
        <SectionSeleksiPS />
      </div>
    </div>
  )
}
